<template>
  <div>
    <banner />
    <steps-mobile></steps-mobile>
    <packages :packages="packages"/>
    <flavors-packages
      :categories_flavors="categories"
      :flavors="flavors"
      :copy_flavors="flavors"
      :show_buttons="true"
    />
    <message-user
      :messages="order.messages"
      @addMessage="addMessage"
      @removeMessage="removeMessage"
    />
    <send-to :from_to="order"/>

    <div class="container-button mt-15">
      <v-btn
        color="accent"
        class="nv-btn nv-btn-large"
        elevation="0"
        @click="goPaymentCampaign()"
        :loading="loading_btn"
      >
        REALIZAR PAGO
      </v-btn>
    </div>

    <div class="d-block d-sm-block d-md-none">
      <swipe-up @validateDataDiloConNieve="goPaymentCampaign('mobile')"></swipe-up>
    </div>

  </div>
</template>

<script>
import Banner from '@/components/store/diloconnieve/Banner'
import Packages from '@/components/store/diloconnieve/Packages'
import FlavorsPackages from '@/components/store/diloconnieve/FlavorsPackage'
import PackageService from '@/services/home.service'
import MessageUser from '@/components/store/diloconnieve/MessageUser'
import SendTo from '@/components/store/diloconnieve/SendTo'
import { mapState } from 'vuex'
import StepsMobile from '@/components/store/diloconnieve/StepsMobile'
import moment from 'moment'
import SwipeUp from '@/components/store/diloconnieve/SwipeUp'

export default {
  components: { Banner, Packages, FlavorsPackages, MessageUser, SendTo, StepsMobile, SwipeUp },
  data() {
    return {
      loading_btn: false,
      packages: [],

      max_flavors_select: 0,
      order: {
        date: moment().format('YYYY-MM-DD'),
        messages: [{message: ''}],
        from: '',
        to: ''
      }
    }
  },
  computed: {
    categories() {
      return this.$store.state.data_home_page.categories_flavors.map(i => {
        return {
          id: i.id,
          name: i.name,
          key_: i.key_
        }
      })
    },
    flavors() {
      return this.$store.state.data_home_page.flavors.filter(i => {
        if (i.id != 16) {
          return i
        }
      })
    },
    ...mapState(['cart'])
  },
  methods: {
    goPaymentCampaign(view = 'web') {
      if (!this.cart.cart_products.length) {
        this.$swal('Debes elegir al menos un producto para continuar', '', 'warning')
        return false
      }
      let empty_messages = this.order.messages.filter(i => {
        return i.message == ''
      })
      if (empty_messages.length) {
        this.$swal('Todos los mensajes agregados debes llenarlos', '', 'warning')
        return false
      }
      if (this.order.from == '' || this.order.to == '') {
        this.$swal('Los campos De y Para deben estar llenos', '', 'warning')
        return false
      }
      this.loading_btn = true
      this.order.date = moment().format('YYYY-MM-DD')
      this.order = {...this.order}
      this.$store.dispatch('setPackageOrder', this.order)
      setTimeout(() => {
        if (view == 'web') {
          this.$router.push('/procesar-pago')
        } else {
          this.$router.push('/checkout')
        }
      }, 1000)
    },
    addMessage() {
      let frascos = this.cart.cart_products.filter(i => {
        if (i.product.category_flavor_id != 3) {
          return i
        }
      })
      let quantity = 0
			frascos.forEach(i => {
				quantity += i.quantity
			})
      if (this.order.messages.length < quantity) {
        this.order.messages.push({message: ''})
      } else {
        this.$swal('La cantidad de mensajes debe ser acorde a la cantidad de frascos elegidos', '', 'warning')
      }
    },
    removeMessage(index) {
      this.order.messages.splice(index, 1)
    },
    async getPackages() {
      const { data:res } = await PackageService.getPackages()
      this.packages = res
    }
  },
  mounted() {
    let date = new Date()
    let view_dcn = localStorage.getItem('view_dcn')
    if (!view_dcn) {
      localStorage.setItem('view_dcn', `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`);
    }

    let campaign_order = localStorage.getItem('campaign_order')
    if (campaign_order) {
      this.order = JSON.parse(campaign_order)
    }
  },
  created() {
    this.getPackages()
  },
  /*destroyed() {
    this.$store.dispatch('setPackageOrder', this.order)
  }*/
}
</script>

<style scoped>
.container-button {
  text-align: center;
}
</style>
